import { ReactNode } from "react";
import AppColorPicker from "../../../../../elements/AppColorPicker";
import { FormBuilder } from "../../../../../types/FormBuilderInterfaces";

interface Props {
  form: FormBuilder;
  setForm: (value: any, key: string) => void;
}

const GeneralStyles = ({ form, setForm }: Props) => {
  const handleSetForm = (value: any, key: string, secondOrderKey?: string) => {
    if (secondOrderKey) {
      return setForm(
        {
          ...form.GeneralStyles,
          //@ts-ignore
          [key]: { ...form.GeneralStyles?.[key], [secondOrderKey]: value },
        },
        "GeneralStyles"
      );
    }
    return setForm({ ...form.GeneralStyles, [key]: value }, "GeneralStyles");
  };

  return (
    <div className="d-flex flex-column">
      <ColorPickerWrapper title="Title Color">
        <AppColorPicker
          value={form.GeneralStyles?.TitleColor || "#ffffff"}
          onChange={(value) => handleSetForm(value, "TitleColor")}
          onClear={() => handleSetForm("#000000", "TitleColor")}
        />
      </ColorPickerWrapper>
      <ColorPickerWrapper title="Description Color">
        <AppColorPicker
          value={form.GeneralStyles?.DescriptionColor || "#ffffff"}
          onChange={(value) => handleSetForm(value, "DescriptionColor")}
          onClear={() => handleSetForm("#000000", "DescriptionColor")}
        />
      </ColorPickerWrapper>
      <ColorPickerWrapper title="Background Color">
        <AppColorPicker
          value={form.GeneralStyles?.BackgroundColor || "#ffffff"}
          onChange={(value) => handleSetForm(value, "BackgroundColor")}
          onClear={() => handleSetForm(undefined, "BackgroundColor")}
        />
      </ColorPickerWrapper>
    </div>
  );
};

export function ColorPickerWrapper({
  title,
  children,
}: {
  title: string;
  children: ReactNode;
}) {
  return (
    <div className="d-flex align-items-center justify-content-between mb-3">
      <label className="text-sm font-weight-500 text-dark mb-0">{title}:</label>
      {children}
    </div>
  );
}

export default GeneralStyles;
